import Checkout from "JS/classes/checkout/Checkout";
//import UsePoints from "JS/classes/UsePoints";

(() => {
    const checkout = new Checkout();
    //new UsePoints('checkout', checkout);
})();
